import PageHeader from "@/components/site/PageHeader";
import { ORG, ORG_ADDRESS_LINE } from "@/lib/org";
import { usePageMeta } from "@/lib/usePageMeta";

const SECTIONS = [
  {
    t: "Information We Collect",
    p: "When you submit a form on this website (Plan Your Visit, Prayer Request, Volunteer, Contact, Newsletter, or WCEP inquiry), we collect the information you choose to provide — typically your name, email address, phone number, and message. We do not sell, rent, or trade your personal information.",
  },
  {
    t: "How We Use Your Information",
    p: "We use your information solely to respond to your request, to pray with you, to connect you with a ministry team, and — if you subscribe — to send church updates. Prayer requests are treated as confidential and shared only with our intercessory prayer team.",
  },
  {
    t: "Email & Communications",
    p: `Transactional and follow-up emails are sent from addresses on our domain (@${ORG.domain}). You may unsubscribe from newsletter communications at any time by replying to any email or contacting ${ORG.email}.`,
  },
  {
    t: "Third-Party Services",
    p: "Our website uses YouTube to deliver livestream and on-demand video. Form submissions may be stored in our secure church-management system so our team can follow up. These providers process data according to their own privacy policies.",
  },
  {
    t: "Cookies",
    p: "This website does not use advertising or tracking cookies. Embedded YouTube players may set cookies governed by Google's privacy policy.",
  },
  {
    t: "Children",
    p: "Our website is not directed to children under 13, and we do not knowingly collect personal information from children online. Kids ministry (RPK) registration is handled in person by a parent or guardian.",
  },
  {
    t: "Your Rights",
    p: `You may request access to, correction of, or deletion of your personal information at any time by emailing ${ORG.email}.`,
  },
];

export default function PrivacyPage() {
  usePageMeta("Privacy Policy & Terms of Use", "Privacy Policy and Terms of Use for the RE//FORM PLACE CHI website.");
  return (
    <div data-testid="privacy-page">
      <PageHeader crumb="Privacy & Terms" eyebrow="Legal" title="Privacy Policy" accent="& Terms" intro="How RE//FORM PLACE CHI handles the information you share with us online." />
      <section className="section bg-[var(--brand-cream)] text-black">
        <div className="container-x max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-zinc-500">Effective June 2026</p>
          {SECTIONS.map((s) => (
            <div key={s.t} className="mt-10" data-testid={`privacy-${s.t.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h2 className="font-display font-black uppercase text-2xl text-black">{s.t}</h2>
              <p className="mt-3 text-zinc-700 leading-relaxed">{s.p}</p>
            </div>
          ))}
          <div className="mt-10" data-testid="terms-of-use">
            <h2 className="font-display font-black uppercase text-2xl text-black">Terms of Use</h2>
            <p className="mt-3 text-zinc-700 leading-relaxed">
              All content on this website — including text, photography, video, and the RE//FORM PLACE CHI
              name and marks — is the property of {ORG.legalName} and may not be reproduced without written
              permission. Sermon and worship content is provided for personal, non-commercial use. Giving is
              voluntary; contributions to {ORG.legalName}, a {ORG.status}, may be tax-deductible to the extent
              permitted by law.
            </p>
          </div>
          <div className="mt-12 p-8 bg-white border border-black/5" data-testid="privacy-contact">
            <h3 className="font-display font-black uppercase text-lg text-black">Questions</h3>
            <p className="mt-2 text-sm text-zinc-700">{ORG.legalName}</p>
            <p className="text-sm text-zinc-700">{ORG_ADDRESS_LINE}</p>
            <a href={`mailto:${ORG.email}`} className="text-sm brand-red hover:underline">{ORG.email}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
